import { FacilityRoles } from "./types";

// Role mappings matching src/containers/teamMembers/constants.ts ROLE_MAPPINGS
export const ROLE_MAPPINGS = {
  CORP: {
    label: "Corporate Administrator",
    id: FacilityRoles.CORPORATE_ADMIN,
  },
  ADM: {
    label: "Administrator",
    id: FacilityRoles.ADMIN,
  },
  SFT: {
    label: "Staffing Coordinator",
    id: FacilityRoles.SHIFT_MANAGEMENT,
  },
  INV: {
    label: "Billing Manager",
    id: FacilityRoles.INVOICES,
  },
  DMT: {
    label: "Supervisor",
    id: FacilityRoles.DOCUMENTS,
  },
  REC: {
    label: "Recruiter",
    id: FacilityRoles.RECRUITMENT,
  },
};

export function getRoleLabels(roles: FacilityRoles[]): string {
  const labels = roles
    .map((roleId) => {
      const mapping = Object.values(ROLE_MAPPINGS).find((m) => m.id === roleId);
      return mapping?.label;
    })
    .filter(Boolean);

  return labels.length > 0 ? labels.join(", ") : "No roles";
}
